<dx-validation-group #loginValidationGroup>
    <dx-responsive-box>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-col></dxi-col>
        <dxi-col></dxi-col>

        <dxi-item>
            <dxi-location screen="md lg" [row]="0" [col]="0"></dxi-location>
            <dxi-location screen="xs sm" [row]="0" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        placeholder="Username"
                        [(value)]="loginParam.username"
                        class="username-input cc-text-required"
                        (onEnterKey)="btnLoginClick(null)"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Username is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location screen="md lg" [row]="0" [col]="1"></dxi-location>
            <dxi-location screen="xs sm" [row]="1" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        placeholder="Password"
                        [(mode)]="passwordMode"
                        [(value)]="loginParam.password"
                        (onEnterKey)="btnLoginClick(null)"
                        class="password-input cc-text-required"
                    >
                        <dxi-button
                            *ngIf="passwordMode === 'password'"
                            name="password"
                            location="after"
                            [options]="passwordShowButton"
                        ></dxi-button>
                        <dxi-button
                            *ngIf="passwordMode !== 'password'"
                            name="password"
                            location="after"
                            [options]="passwordHideButton"
                        ></dxi-button>
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item [visible]="loginAttempts >= noOfAllowedAttempts">
            <dxi-location screen="md lg" [row]="1" [col]="0" [colspan]="2"></dxi-location>
            <dxi-location screen="xs sm" [row]="2" [col]="0" [colspan]="2"></dxi-location>
            <div *dxTemplate class="align-items-center">
                <div class="user-auth-container-links-container">
                    <re-captcha
                        #reCaptcha
                        [siteKey]="recaptchaSiteKey"
                        (resolved)="onRecaptchaResolved($event)"
                    ></re-captcha>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location screen="md lg" [row]="2" [col]="0"></dxi-location>
            <dxi-location screen="xs sm" [row]="3" [col]="0"></dxi-location>
            <div *dxTemplate class="user-auth-container-input-wrapper login-button-wrapper">
                <div class="login-button-content">
                    <dx-button
                        #btnLogin
                        text="Log in"
                        class="login-button"
                        type="default"
                        [width]="btnLoginAndResetWidth"
                        [height]="30"
                        (onClick)="btnLoginClick($event)"
                    ></dx-button>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location screen="md lg" [row]="2" [col]="1"></dxi-location>
            <dxi-location screen="xs sm" [row]="3" [col]="1"></dxi-location>
            <div *dxTemplate class="user-auth-container-input-wrapper align-items-start">
                <dx-button
                    #btnResetPassword
                    text="Forgot Password"
                    type="default"
                    class="reset-button"
                    [width]="btnLoginAndResetWidth"
                    [height]="30"
                    (onClick)="btnResetPasswordClick($event)"
                ></dx-button>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location screen="md lg" [row]="3" [col]="0" [colspan]="2"></dxi-location>
            <dxi-location screen="xs sm" [row]="4" [col]="0" [colspan]="2"></dxi-location>
            <div *dxTemplate class="align-items-center">
                <div class="user-auth-container-links-container">
                    <a class="choose-portal-hyperlink" (click)="linkChooseDifferentPortalClick()">
                        Choose a different portal
                    </a>
                </div>
            </div>
        </dxi-item>
    </dx-responsive-box>
</dx-validation-group>

<dx-load-panel
    #loadPanelLogin
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#loginContainer' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
